var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.edit)?_c('div',{staticClass:"thumbnail"},[_c('img',{style:(_vm.style),attrs:{"src":_vm.src}})]):_c('div',{staticClass:"thumbnail"},[_c('img',{style:(_vm.style),attrs:{"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }